export default __webpack_public_path__ + "static/media/ic-star.e67282e6.svg";